"use strict";

var _toConsumableArray = require("/builds/hooxitech/polgozar-front-end/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zStartEndOfMonth = exports.zMonth = exports.zYear = exports.zDateDetails = exports.SingletonYearEvent = exports.partyDays = exports.NaborsDay = exports.ZDays = exports.ZMonthlyHoliday = exports.ZMonthlyEvents = exports.zMonthNames = exports.Events = exports.LabelColors = void 0;
var moment_jalaali_1 = __importDefault(require("moment-jalaali"));
// import NoroozImage from './nowrooz.png';
// import Zoroaster from './zoroaster.png';
// import SizdahBeDar from './sizdebedar.png';
var LabelColors;
(function (LabelColors) {
  LabelColors["important"] = "#eb2f9612";
  LabelColors["semiImportant"] = "#ffb30026";
})(LabelColors = exports.LabelColors || (exports.LabelColors = {}));
exports.Events = {
  1: [{
    fa: "جشن نوروز",
    en: "Nowrūz",
    isHoliday: true,
    labelColor: LabelColors.important
    // bgImage: NoroozImage,
  }],

  6: [{
    fa: "زادروز اشوزرتشت",
    en: "Zoroaster Birthday",
    isZHoliday: true
    // bgImage: Zoroaster,
  }],

  7: [{
    fa: "زیارت پیر هریشت",
    en: "Pīre Herīsht",
    type: "ziyarat",
    duration: 5
  }],
  13: [{
    fa: "سیزده بدر",
    en: "Sīzdah Bedar"
    // bgImage: SizdahBeDar,
  }],

  19: [{
    fa: "جشن فروردین گان (فرودوگ)",
    en: "Farvardingân",
    isZHoliday: true,
    labelColor: LabelColors.semiImportant
  }],
  33: [{
    fa: "جشن اردیبهشت گان",
    en: "Ardībeheshtgān",
    labelColor: LabelColors.semiImportant
  }],
  41: [{
    fa: "چهره میدیوزرم گاه",
    en: "Maīdīyozarem Gāhānbār",
    type: "gohanbar",
    duration: 5
  }],
  66: [{
    fa: "جشن خردادگان",
    en: "Khordādgān",
    labelColor: LabelColors.semiImportant
  }],
  86: [{
    fa: "زیارت پیرسبز",
    en: "Pīre Sabz",
    type: "ziyarat",
    duration: 5
  }],
  91: [{
    fa: "پرسه تیرماه",
    en: "Porseh Tīrgān"
  }],
  95: [{
    fa: "زیارت پیر نارستانه",
    en: "Pīre Nārestāne",
    type: "ziyarat",
    duration: 5
  }],
  101: [{
    fa: "چهره میدیوشهم گاه",
    en: "Maīdīyoshahem Gāhānbār",
    type: "gohanbar",
    duration: 5
  }],
  103: [{
    fa: "جشن تیرگان",
    en: "Tirgān",
    labelColor: LabelColors.important
  }],
  106: [{
    fa: "زیارت پارس بانو",
    en: "Pārsbānū",
    type: "ziyarat",
    duration: 5
  }],
  127: [{
    fa: "جشن امردادگان",
    en: "Amordādgān",
    labelColor: LabelColors.semiImportant
  }],
  136: [{
    fa: "زیارت پیرنارکی",
    en: "Pīre Nārakī",
    type: "ziyarat",
    duration: 5
  }],
  154: [{
    fa: "جشن شهریورگان",
    en: "Shahrīvargān",
    labelColor: LabelColors.semiImportant
  }],
  176: [{
    fa: "چهره پیتیو شهم گاه",
    en: "Paītīyoshahem Gāhānbār",
    type: "gohanbar",
    duration: 5
  }],
  196: [{
    fa: "جشن مهرگان",
    en: "Mehregān",
    isZHoliday: true,
    labelColor: LabelColors.important
  }],
  206: [{
    fa: "چهره ایاسرم  گاه",
    en: "Aīyāthrem Gāhānbār",
    type: "gohanbar",
    duration: 5
  }],
  220: [{
    fa: "جشن آبانگان",
    en: "Ābāngān",
    labelColor: LabelColors.semiImportant
  }],
  249: [{
    fa: "جشن آذرگان",
    en: "Āzargān",
    labelColor: LabelColors.semiImportant
  }],
  276: [{
    fa: "شب چله",
    en: "Chelle",
    labelColor: LabelColors.important
  }],
  271: [{
    fa: "جشن دیگان",
    en: "Deīgān",
    labelColor: LabelColors.semiImportant
  }],
  278: [{
    fa: "جشن دیگان",
    en: "Deīgān",
    labelColor: LabelColors.semiImportant
  }],
  281: [{
    fa: "سالروز درگذشت اشوزرتشت",
    en: "Zoroaster’s Passing",
    isZHoliday: true,
    labelColor: LabelColors.important
    // bgImage: Zoroaster,
  }],

  285: [{
    fa: "جشن دیگان",
    en: "Deīgān",
    labelColor: LabelColors.semiImportant
  }],
  286: [{
    fa: "چهره میدیاریم گاه",
    en: "Maīdīyārem Gāhānbār",
    type: "gohanbar",
    duration: 5
  }],
  293: [{
    fa: "جشن دیگان",
    en: "Deīgān",
    labelColor: LabelColors.semiImportant
  }],
  302: [{
    fa: "جشن بهمنگان",
    en: "Bahmangān",
    labelColor: LabelColors.semiImportant
  }],
  316: [{
    fa: "جشن سده",
    en: "Sadeh",
    isZHoliday: true,
    labelColor: LabelColors.important
  }],
  331: [{
    fa: "پرسه اسفندماه",
    en: "Porseh Esfandgān"
  }],
  335: [{
    fa: "جشن اسفندگان",
    en: "Esfandgān",
    labelColor: LabelColors.semiImportant
  }],
  361: [{
    fa: "چهره همس پت میدیم گاه",
    en: "Hamaspathmaīdīyem Gāhānbār",
    type: "gohanbar",
    duration: 5
  }, {
    fa: "پنجی",
    en: "Panjeh",
    type: "gohanbar",
    duration: 5
  }]
};
exports.zMonthNames = [{
  fa: "فروردین",
  en: "Farvardin"
}, {
  fa: "اردیبهشت",
  en: "Ardibehesht"
}, {
  fa: "خرداد",
  en: "Khordād"
}, {
  fa: "تیر",
  en: "Tīr"
}, {
  fa: "امرداد",
  en: "Amordād"
}, {
  fa: "شهریور",
  en: "Shahrīvar"
}, {
  fa: "مهر",
  en: "Mehr"
}, {
  fa: "آبان",
  en: "Ābān"
}, {
  fa: "آذر",
  en: "Āzar"
}, {
  fa: "دی",
  en: "Deī"
}, {
  fa: "وهمن",
  en: "Vahman"
}, {
  fa: "سپندارمزد",
  en: "Sepandārmazd"
}, {
  fa: "گاتابیو",
  en: "Gāthābīyū"
}];
exports.ZMonthlyEvents = {
  8: [{
    fa: "زیارت پیر مراد",
    en: "Pire Morād",
    type: "ziyarat"
  }],
  15: [{
    fa: "زیارت پیر مهر ایزد",
    en: "Pīre Mehrīzed",
    type: "ziyarat"
  }],
  20: [{
    fa: "زیارت شاورهرام ایزد",
    en: "Shāhvrahrāmīzed",
    type: "ziyarat"
  }],
  25: [{
    fa: "زیارت ستی پیر",
    en: "Setīpīr",
    type: "ziyarat"
  }]
};
exports.ZMonthlyHoliday = [0, 7, 14, 22];
exports.ZDays = [{
  en: "Ahūrmazd",
  fa: "اورمزد"
}, {
  en: "Vahman",
  fa: "وهمن",
  info: "This day is also called Vamer\u016B, which is short for Vahman R\u016Bzh or Bahman R\u016Bz (Vahman or Bahman\u2019s Day).\nBahman or Vahman is short for vah = voh\u016B = good and man = manesh = mind. It is short for Voh\u016B Manah = Good mind. Voh\u016Bman is an Amsh\u0101spand. His color is white. His connection is to animals. This is why this day, Vahman, is Nabor.\nA Sofreh is laid out on this day. In many houses the story of the Moshkel Gosh\u0101 or Problem Opener/Solver is told."
}, {
  en: "Ardībehesht",
  fa: "اردیبهشت"
}, {
  en: "Shahrīvar",
  fa: "شهریور"
}, {
  en: "Sepandārmazd",
  fa: "سپندارمذ"
}, {
  en: "Khordād",
  fa: "خرداد"
}, {
  en: "Amordād",
  fa: "امرداد"
}, {
  en: "Dei Be Āzar",
  fa: "دی به آذر"
}, {
  en: "Āzar",
  fa: "آذر"
}, {
  en: "Ābān",
  fa: "آبان"
}, {
  en: "Khor",
  fa: "خور"
}, {
  en: "Māh",
  fa: "ماه"
}, {
  en: "Tīr",
  fa: "تیر"
}, {
  en: "Geūsh",
  fa: "گوش"
}, {
  en: "Deī Be Mehr",
  fa: "دی به مهر"
}, {
  en: "Mehr",
  fa: "مهر"
}, {
  en: "Sorūsh",
  fa: "سروش"
}, {
  en: "Rashn",
  fa: "رشن"
}, {
  en: "Farvardin",
  fa: "فروردین"
}, {
  en: "Varahrām",
  fa: "ورهرام"
}, {
  en: "Rām",
  fa: "رام"
}, {
  en: "Vād",
  fa: "واد"
}, {
  en: "Deī Be Dīn",
  fa: "دی بدین"
}, {
  en: "Dīn",
  fa: "دین"
}, {
  en: "Ard ",
  fa: "ارد"
}, {
  en: "Ashtād",
  fa: "اشتاد"
}, {
  en: "Āsmān",
  fa: "آسمان"
}, {
  en: "Zāmyād",
  fa: "زامیاد"
}, {
  en: "Māntraspand",
  fa: "مانتره سپند"
}, {
  en: "Anārām",
  fa: "انارام"
}, {
  en: "Ahnavad",
  fa: "اهنود"
}, {
  en: "Oshtavad",
  fa: "اشتود"
}, {
  en: "Sepantamad",
  fa: "سپنتمد"
}, {
  en: "Vohūkhshatr",
  fa: "وهوخشتر"
}, {
  en: "Vahīshtoesh",
  fa: "وهشتواش"
}, {
  en: "Avardād Sāl Gāh",
  fa: "اورداد"
}];
exports.NaborsDay = [1, 11, 13, 20];
exports.partyDays = [7, 14, 22];
exports.SingletonYearEvent = {};
var reformatEvents = function reformatEvents() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, moment_jalaali_1.default)();
  var weekTypeFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "week";
  var jDate = (0, moment_jalaali_1.default)(date); // convert to Jalali date
  var year = jDate.format("jYYYY");
  if (exports.SingletonYearEvent[year]) {
    return exports.SingletonYearEvent[year];
  }
  exports.SingletonYearEvent[year] = Object.keys(exports.Events).reduce(function (modifiedEvents, key) {
    var keyIdx = parseInt(key, 10);
    var events = exports.Events[key];
    var eventsDate = jDate.clone().jDayOfYear(keyIdx);
    var endOfWeek = eventsDate.clone().endOf(weekTypeFormat);
    var eventToEndOfWeek = parseInt(endOfWeek.format("jDDD"), 10) - keyIdx + 1;
    var newModifiedEvents = Object.assign({}, modifiedEvents);
    var newEvents = events.map(function (event) {
      var rollOverDuration = 0;
      if (event.duration) {
        rollOverDuration = event.duration - eventToEndOfWeek;
        // copy event into other following date so it can be shown in next date
        for (var i = 1; i < event.duration; i += 1) {
          var nextDate = eventsDate.clone().add(i, "day").format("jDDD");
          var nextDateEvent = Object.assign(Object.assign({}, event), {
            duration: 0,
            hideOnCalendar: true
          });
          if (!newModifiedEvents[nextDate]) {
            newModifiedEvents[nextDate] = [];
          }
          newModifiedEvents[nextDate].unshift(nextDateEvent);
        }
      }
      if (rollOverDuration > 0 && eventToEndOfWeek > 0) {
        // means it rolls over to the next week
        var firstDayOfNextWeek = endOfWeek.clone().add(1, "day").format("jDDD");
        var nextWeekEvent = Object.assign(Object.assign({}, event), {
          duration: rollOverDuration,
          openStarted: true,
          hideOnCalendar: false
        });
        if (!newModifiedEvents[firstDayOfNextWeek]) {
          newModifiedEvents[firstDayOfNextWeek] = [];
        }
        var indexOfExsitingEvent = newModifiedEvents[firstDayOfNextWeek].findIndex(function (e) {
          return e.en === event.en;
        });
        if (indexOfExsitingEvent >= 0) {
          newModifiedEvents[firstDayOfNextWeek][indexOfExsitingEvent] = nextWeekEvent;
        } else {
          newModifiedEvents[firstDayOfNextWeek].unshift(nextWeekEvent);
        }
        return Object.assign(Object.assign({}, event), {
          duration: eventToEndOfWeek,
          openEnded: true
        });
      }
      return event;
    });
    newModifiedEvents[key] = [].concat(_toConsumableArray(newModifiedEvents[key] || []), _toConsumableArray(newEvents));
    return newModifiedEvents;
  }, {});
  return exports.SingletonYearEvent[year];
};
var zDateDetails = function zDateDetails() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, moment_jalaali_1.default)();
  var weekTypeFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "week";
  var jDate = (0, moment_jalaali_1.default)(date); // convert to Jalali date
  var modifiedEvents = reformatEvents(jDate, weekTypeFormat);
  var dayInYear = parseInt(jDate.format("jDDD"), 10);
  var dayInZMonth = dayInYear % 30 - 1;
  dayInZMonth = dayInZMonth < 0 ? 29 : dayInZMonth;
  dayInZMonth = dayInYear > 360 ? dayInZMonth + 30 : dayInZMonth;
  var name = exports.ZDays[dayInZMonth];
  var isNabor = exports.NaborsDay.includes(dayInZMonth);
  var isParyDay = exports.partyDays.includes(dayInZMonth);
  var day = parseInt(jDate.format("jDDD"), 10) % 30;
  var zDay = day === 0 ? "30" : String(day);
  var monthEvents = exports.ZMonthlyEvents[zDay] || [];
  var events = [].concat(_toConsumableArray(modifiedEvents[dayInYear] || []), _toConsumableArray(monthEvents));
  return {
    name: name,
    isNabor: isNabor,
    isParyDay: isParyDay,
    events: events,
    day: zDay
  };
};
exports.zDateDetails = zDateDetails;
var zYear = function zYear() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, moment_jalaali_1.default)();
  var jDate = (0, moment_jalaali_1.default)(date); // convert to Jalali date
  return parseInt(jDate.format("jYYYY"), 10) + 2359;
};
exports.zYear = zYear;
var zMonth = function zMonth() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, moment_jalaali_1.default)();
  var jDate = (0, moment_jalaali_1.default)(date); // convert to Jalali date
  var dayInYear = parseInt(jDate.format("jDDD"), 10);
  var month = Math.ceil(dayInYear / 30);
  return {
    month: month,
    name: exports.zMonthNames[month - 1]
  };
};
exports.zMonth = zMonth;
var zStartEndOfMonth = function zStartEndOfMonth() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, moment_jalaali_1.default)();
  var jDate = (0, moment_jalaali_1.default)(date); // convert to Jalali date
  var currentMonthIdx = (0, exports.zMonth)(jDate).month;
  var startEndMonthDay = [0, 30];
  if (currentMonthIdx === 1) {
    startEndMonthDay = [0, 30];
  } else if (currentMonthIdx === 13) {
    startEndMonthDay = [360, parseInt(jDate.clone().endOf("jYear").format("jDDD"), 10)];
  } else {
    startEndMonthDay = [(currentMonthIdx - 1) * 30, currentMonthIdx * 30];
  }
  var statEndMonth = [jDate.clone().startOf("jYear").add(startEndMonthDay[0], "day"), jDate.clone().startOf("jYear").add(startEndMonthDay[1], "day").subtract(1, "day")];
  return statEndMonth;
};
exports.zStartEndOfMonth = zStartEndOfMonth;